import { useState, useEffect, useContext } from 'react';
import './RecipeActionButton.css';
import './CommentModal.css';
import InputContext from './InputContext';
import { SocketContext } from '../SocketContext';

const baseURL = process.env.REACT_APP_API_URL;

function CommentButton({ recipeId }) {
    const [showModal, setShowModal] = useState(false);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const { username } = useContext(InputContext);
    const socket = useContext(SocketContext);

    useEffect(() => {
        if (!showModal) return;

        const fetchComments = async () => {
            const res = await fetch(`${baseURL}/recipes/${recipeId}/comments`);
            const data = await res.json();
            setComments(data);
        };

        fetchComments();

        const handleNewComment = ({ recipeId: updatedId, comment }) => {
            if (updatedId === recipeId) {
                setComments((prev) => [...prev, comment]);
            }
        };

        socket.on('commentAdded', handleNewComment);

        return () => socket.off('commentAdded', handleNewComment);
    }, [showModal, recipeId, socket]);


    const handlePost = async () => {
        if (!newComment.trim()) return;
        const res = await fetch(`${baseURL}/recipes/${recipeId}/comments`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, text: newComment })
        });
        const data = await res.json();
        //setComments([...comments, data]);
        setNewComment('');
    };

    return (
        <>
            <button className="recipe-button" onClick={() => setShowModal(true)}>
                💬 Comments
            </button>

            {showModal && (
                <div className="comment-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="comment-modal" onClick={e => e.stopPropagation()}>
                        <div className="comment-list">
                            {comments.map((c, i) => (
                                <div key={i} className="comment-item">
                                    <strong>{c.username}</strong> <span>{new Date(c.postedAt).toLocaleString()}</span>
                                    <p>{c.text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="comment-input-area">
                            <input
                                type="text"
                                value={newComment}
                                onChange={(e) => setNewComment(e.target.value)}
                                placeholder="Write a comment..."
                            />
                            <button onClick={handlePost}>Post</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CommentButton;